class AssetEnvLight {
    constructor() {
        /**
         * @type {THREE.CubeTexture}
         */
        this._cubeMap = null;
        /**
         * @type {THREE.DataTexture}
         */
        this._ercMap = null;
        /**
         * @type {string}
         */
        this._activeType = "cube";

        this._resolution = 1;
    }

    get cubeMap() { return this._cubeMap; }
    set cubeMap(v) { this._cubeMap = v; }

    get ercMap() { return this._ercMap; }
    set ercMap(v) {
        if (v === this._ercMap) return;
        if (this._ercMap) this._ercMap.dispose();
        this._ercMap = v;
    }

    get type() { return this._activeType; }
    set type(type) {
        if (type === this._activeType) return;
        switch (type) {
            case "cube":
                if (this._ercMap) this._ercMap.dispose();
                this._ercMap = null;
                break;
            case "erc":
                this._cubeMap.mipmaps = [];
                break;
            default:
                throw new Error("Invalid environment type:", type)
        }

        this._activeType = type;
    }

    get activeMap() {
        switch (this._activeType) {
            case "erc": return this._ercMap;
            case "cube":
            default:
                return this._cubeMap;
        }
    }

    get resolution() { return this._resolution; }
    set resolution(v) { this._resolution = v; }
}

export default AssetEnvLight;
export { AssetEnvLight };